import { Box, useTheme } from '@mui/material';
import { tokens } from '../../../../global/theme/tokens';

// flat list of task rows: no card around a task, just a thin line between them
const TaskCardList = ({ children, className = '' }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  return (
    <Box
      className={`flex flex-col ${className}`}
      sx={{
        '& > *:not(:last-child)': {
          borderBottom: `1px solid ${colors.text}15`,
        },
      }}
    >
      {children}
    </Box>
  );
};

export default TaskCardList;
